import { createFileRoute } from "@tanstack/react-router";
import { BrokerageAccounts } from "@/components/BrokerageAccounts";

function RouteComponent() {
  return <BrokerageAccounts />;
}

export const Route = createFileRoute("/_authenticated/brokerage-accounts/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
